import { MotionConfig } from 'motion/react';
import { Link } from '@tanstack/react-router';
import SectionHead from '../ui/SectionHead.jsx';
import Button from '../ui/Button.jsx';
import CaseStudyCard from '../primitives/CaseStudyCard.jsx';
import { caseStudies } from '../../content/case-studies-manifest.js';
import { flagshipBuilds } from '../../content/flagshipBuilds.js';

/**
 * FlagshipBuilds — homepage showcase of the three flagship platforms,
 * rendered straight from the case-studies manifest so the cards always
 * match the published studies. Replaced WorkInFlight in July 2026.
 */
export default function FlagshipBuilds() {
  const entries = flagshipBuilds.slugs
    .map((slug) => caseStudies.find((c) => c.slug === slug))
    .filter(Boolean);

  if (entries.length === 0) return null;

  return (
    <section id="flagship-builds" className="section-pad bg-surface text-ink-50 border-t border-white/[.06]">
      <div className="container-page">
        <SectionHead
          eyebrow={flagshipBuilds.eyebrow}
          heading={flagshipBuilds.heading}
          description={flagshipBuilds.description}
        />

        <MotionConfig reducedMotion="user">
          <div className="grid md:grid-cols-3 gap-4 md:gap-5">
            {entries.map((c, i) => (
              <CaseStudyCard key={c.slug} entry={c} delay={0.06 * i} />
            ))}
          </div>
        </MotionConfig>

        <div className="mt-6">
          <Button variant="ghost" as={Link} to="/case-studies">
            {flagshipBuilds.linkLabel}
          </Button>
        </div>
      </div>
    </section>
  );
}
